<!-- dialog view -->
<h2 mat-dialog-title>{{ dataModule.title }}</h2>
<mat-dialog-content class="mat-typography">
  <p>
    {{ dataModule.description }}
  </p>
  @if (dataModule.list_file?.length) {
    <ul>
      @for (item of dataModule.list_file; track item) {
        <li>{{ item }}</li>
      }
    </ul>
  }
  <p [innerHTML]="dataModule.footer_text"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="bg-error text-white" mat-dialog-close>Close</button>
</mat-dialog-actions>
